import { useEffect, useMemo, useState } from 'react';
import { allLessons } from '../data/lessons';

const STORAGE_KEY = 'medical-coding-prep-progress';

function readProgress() {
  try {
    const stored = JSON.parse(localStorage.getItem(STORAGE_KEY));
    return Array.isArray(stored) ? stored : [];
  } catch {
    return [];
  }
}

export default function useProgress() {
  const [completedLessons, setCompletedLessons] = useState(readProgress);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(completedLessons));
  }, [completedLessons]);

  const toggleLesson = (lessonId) => {
    setCompletedLessons((current) =>
      current.includes(lessonId)
        ? current.filter((id) => id !== lessonId)
        : [...current, lessonId]
    );
  };

  const completionPercentage = useMemo(() => {
    if (!allLessons.length) return 0;
    return Math.round((completedLessons.length / allLessons.length) * 100);
  }, [completedLessons]);

  return {
    completedLessons,
    completionPercentage,
    toggleLesson
  };
}